import { useState } from "react";

export default function ShareButtons({ title }: { title: string }) {
  const [copied, setCopied] = useState(false);

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";

  const handleNativeShare = async () => {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, url: shareUrl });
      } catch {
        /* user cancelled */
      }
    } else {
      handleCopy();
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="flex items-center flex-wrap gap-2">
      <span className="text-sm text-foreground-500 mr-1">分享：</span>
      <button
        type="button"
        onClick={handleNativeShare}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-sm hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-share-line" />
        系统分享
      </button>
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-foreground-700 text-sm hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className={copied ? "ri-check-line text-accent-600" : "ri-link"} />
        {copied ? "已复制链接" : "复制链接"}
      </button>
    </div>
  );
}